import './CountdownPage.css'
import {React} from 'react';
import logo from "./images/logos/TROPHYEDDYLOGO_graypurple_text.png"


function CountdownPage() {

  return (
    <div className="background-countdown">
      <div className="overlay-countdown">
        <div style={{ overflow: 'hidden' }} className="content-countdown">
          <div>
            <div className='logo-container-landing'>
                <img src={logo} alt="Logo" className="landing-logo" /> 
                
            </div>
           
        </div>
      </div>
    </div>
  </div>
  );
}

export default CountdownPage;